import Client from "@/http/client";
import {
  SupportPopupDto,
  SupportPopupListDto,
  SupportPopupSaveDto,
} from "@/http/dto/supportPopup";

export class SupportPopups {
  static async getPopups(params: {
    page: number;
    take: number;
    status?: string;
    keyword?: string;
  }) {
    return await Client.get<SupportPopupListDto>("/v2/supporter/popups", params);
  }

  static async getPopup(objectId: string) {
    return await Client.get<SupportPopupDto>(`/v2/supporter/popups/${objectId}`);
  }

  static async create(saveDto: SupportPopupSaveDto) {
    return await Client.post<SupportPopupDto>("/v2/supporter/popups", saveDto);
  }

  static async update(objectId: string, saveDto: SupportPopupSaveDto) {
    return await Client.put<SupportPopupDto>(`/v2/supporter/popups/${objectId}`, saveDto);
  }

  static async delete(objectId: string) {
    return await Client.del(`/v2/supporter/popups/${objectId}`);
  }
}
